<template>
  <div class="map-page">
    <v-container fluid>
      <div class="callcenter-filials-list">
        <!--        <breadcrumbs/>-->
        <v-row>
          <v-col>
            <h1 class="mb-4 mt-3">
              Филиалы, работающие с колл-центром
            </h1>
          </v-col>
          <v-col class="text-right">
            <v-btn
              v-if="userCan('crm.callcenter-filials.edit')"
              depressed
              color="success"
              large
              @click="showAddFilialPopup = true"
            >
              <v-icon
                left
                v-text="`mdi-plus`"
              />
              Добавить
            </v-btn>
          </v-col>
        </v-row>

        <loader
          v-if="loading"
          fixed
        />
        <template v-else-if="notEmptyFilialsList">
          <v-row>
            <v-col
              v-for="filial in filials"
              :key="filial.id"
              sm="3"
            >
              <pickup-point
                name="point"
                :value="filial.id"
                :item="filial"
                :selectable="false"
              >
                <template v-slot:right-bottom="{item}">
                  <div
                    v-if="userCan('crm.callcenter-filials.edit')"
                    class="filial-actions"
                  >
                    <v-menu
                      offset-y
                      transition="slide-y-transition"
                      right
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="filial-actions__activator"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <font-awesome-icon
                            icon="cog"
                            class="filial-actions__activator_icon"
                          />
                        </div>
                      </template>
                      <v-list>
                        <v-list-item
                          v-ripple
                          class="filial-actions__list_item"
                          @click="showRemoveDialog(item)"
                        >
                          <font-awesome-icon
                            icon="trash"
                            class="filial-actions__list_item_icon"
                          />
                          Отключить филиал от Коллцентра
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </pickup-point>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <h3 class="empty-text">
            Нет филиалов работающих с Кол-центром
          </h3>
        </template>
      </div>
    </v-container>
    <filial-select-popup
      v-model="showAddFilialPopup"
      :on-submit="addCallCenterFilial"
    />

    <v-dialog
      v-model="showRemoveFilialDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Вы хотите отключить филиал от Колцентра?
        </v-card-title>
        <v-card-text class="remove-dialog__filial-name">
          {{ removedFilial.name }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            depressed
            color="error"
            :loading="removing"
            :disabled="removing"
            @click="removeCallCenterFilial(removedFilial.id)"
          >
            Отключить
          </v-btn>
          <v-btn
            depressed
            :loading="removing"
            :disabled="removing"
            @click="closeRemoveDialog"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import _ from 'lodash'
  import FilialDataService from '@/services/api/FilialDataService'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import PickupPoint from '@/components/order-processing/order-components/second-step/PickupPoint.vue'
  import FilialSelectPopup from '@/components/ui/FilialSelectPopup.vue'
  import filialsApi from '@/api/filials'

  export default {
    name: 'CallCenterFilials',
    components: {
      FilialSelectPopup,
      PickupPoint,
      Loader,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        loading: true,
        filials: [],
        showAddFilialPopup: false,
        showRemoveFilialDialog: false,
        removedFilial: {},
        removing: false,
      }
    },
    computed: {
      notEmptyFilialsList () {
        return !_.isEmpty(this.filials)
      },
    },
    async created () {
      await this.loadFilials()
      this.loading = false
    },
    methods: {
      async loadFilials () {
        this.loading = true
        try {
          this.filials = await FilialDataService.getUseCallCenterItems()
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.$store.dispatch('branches/fetchBranches')
        this.loading = false
      },
      openMap (filial) {
        this.$router.push(`/geo/couriers-map?filialId=${filial.id}`)
      },
      async addCallCenterFilial (filialId) {
        try {
          await filialsApi.connectToCallCenter(filialId)
          this.loadFilials()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
      },

      showRemoveDialog (filial) {
        console.log(filial)
        this.removedFilial = filial
        this.showRemoveFilialDialog = true
      },
      closeRemoveDialog () {
        this.showRemoveFilialDialog = false
        this.removedFilial = {}
      },

      async removeCallCenterFilial (filialId) {
        this.removing = true
        try {
          await filialsApi.disconnectFromCallCenter(filialId)
          this.closeRemoveDialog()
          this.loadFilials()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.removing = false
      },
    },

  }
</script>

<style scoped lang="less">
.callcenter-filials-list {
  .filial-actions {
    &__activator {

    }

    &__activator_icon {
      font-size: 22px;
      color: @color-btn-dark-grey;
    }

    &__list_item {

    }

  }

}
.filial-actions__list_item_icon {
  color: @color-btn-grey;
  margin-right: 10px;
}

.remove-dialog__filial-name {
  color: black !important;
}

</style>
